import { defineComponent } from "vue";

import { COMPONENT_NAME } from "./attributes";

import { AuthHeader, AuthIntroduction } from "@/components/layouts/auth";

export default defineComponent({
  name: COMPONENT_NAME,
  components: {
    AuthHeader,
    AuthIntroduction,
  },
});
